import { Button } from '@app/components/various/Button';
import { SuccessCircleOutline } from '@app/components/various/Icons';
import { StickyModalFooter } from '@app/components/various/Modal';
import { Notification } from '@app/components/various/Notification';
import { getOrderId, getSelectionImportWarning } from '@app/ducks';
import { compiledPaths } from '@app/paths';
import { useModalVisibility } from '@app/utils/hooks';
import { isEmpty } from '@app/utils/isEmpty';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

export const SelectionImportSuccess = () => {
  const { t } = useTranslation(['common', 'selections']);
  const { hideModal } = useModalVisibility('SelectionImportModal');

  const orderId = useSelector(getOrderId);
  const warningMessage = useSelector(getSelectionImportWarning);

  return (
    <div className="w-full">
      <div className="mt-2 flex flex-col items-center gap-1">
        <SuccessCircleOutline className="size-10 text-success-47" />
        <div className="body-2">{t('common:import_completed')}</div>
      </div>
      {!isEmpty(warningMessage) && (
        <Notification type="warning" message={warningMessage} isBordered className="mb-3 mt-6 whitespace-pre-wrap" />
      )}
      <StickyModalFooter>
        <div className="flex justify-end gap-2">
          <Button color="secondary" variant="ghost" onClick={hideModal}>
            {t('common:keep_browsing')}
          </Button>
          <Button as={Link} to={compiledPaths.ORDER_DETAILS({ id: orderId })} onClick={hideModal}>
            {t('selections:see_my_selection')}
          </Button>
        </div>
      </StickyModalFooter>
    </div>
  );
};
